module.exports = __webpack_public_path__ + "img/web.3e66ff67.jpg";